// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"2c6b95e2","380":"7efe7ceb","467":"c7584c48","688":"a0938b0e","702":"2c6b95e2","740":"2c6b95e2"}[chunkId] + ".chunk.css";
};